import { Module, Mutation, VuexModule } from 'vuex-module-decorators';

@Module({
  name: 'axios-loading',
  stateFactory: true,
  namespaced: true
})
export default class AxiosLoading extends VuexModule {
  private loading: boolean = false;
  private currentRequests: number = 0;
  private requestsList: Array<string> = [];

  @Mutation
  incrementLoading() {
    this.currentRequests++;
    this.loading = this.currentRequests !== 0;
  }

  @Mutation
  decrementLoading() {
    this.currentRequests--;
    this.loading = this.currentRequests !== 0;
  }

  // This is only for the typo3 page requests
  @Mutation
  addToCurrentRequests(url: string) {
    this.requestsList.push(url);
  }

  // This is only for the typo3 page requests
  @Mutation
  removeFromCurrentRequests(url: string) {
    const index = this.requestsList.indexOf(url);
    if (index < 0) {
      return;
    }

    this.requestsList.splice(index, 1);
  }

  get currentlyLoading() {
    return this.loading;
  }

  // We use this value to determine when a page is pending. We add a url to the request list when fetching, and remove again when done
  get currentlyLoadingPage(): boolean {
    return this.requestsList.some((url) => url.includes('id='));
  }
}
